import { useStoreState } from 'easy-peasy';
import {
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { ACTIONLIST } from './Report.reducer';
import { KeyboardDatePicker } from '@material-ui/pickers';
import {
  DatepickerStartDate,
  ProcedureRecordTypeList,
  globalDateEntity,
} from '../../constants/applicationConstants';
import { stringConstants } from '../../constants/stringConstants';
import moment from 'moment';
import ChipInput from 'material-ui-chip-input';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const filterValueConfig = {
  multipleSelect: [
    'entity-businesslines-title',
    'asso-businesslines-title',
    'entity-policies-lob_title',
    'entity-clients-title',
    'asso-clients-title',
    'entity-programs-shortname',
    'asso-programs-shortname',
  ],
  singleSelect: [
    'entity-programs-title',
    'entity-policies-record_type',
    'asso-programs-title',
    'entity-programs-sourcing',
    'entity-instructions-record_type',
    'asso-instructions-record_type',
    'asso-procedures-record_type',
    'asso-programs-sourcing',
    'asso-policies-record_type',
  ],
  mapping: {
    'entity-businesslines-title': 'businessLine',
    'asso-businesslines-title': 'businessLine',
    'entity-policies-record_type': 'policy_type',
    'asso-policies-record_type': 'policy_type',
    'entity-policies-lob_title': 'businessLine',
    'entity-clients-title': 'clients',
    'asso-clients-title': 'clients',
    'entity-programs-shortname': 'programs-short',
    'asso-programs-shortname': 'programs-short',
    'entity-programs-title': 'programs',
    'asso-programs-title': 'programs',
    'entity-programs-sourcing': 'program_vendor',
    'asso-programs-sourcing': 'program_vendor',
    'asso-instructions-record_type': 'instruction-record_type',
    'entity-instructions-record_type': 'instruction-record_type',
    'asso-procedures-record_type': 'procedures-record_type',
  },
  status: [
    'enum-status',
    'prior_auth_exumption',
    'user_type',
    'transaction_source',
    'procedure-enum-status',
    'pa_status',
  ],
  'enum-status': {
    heading: 'Status',
    list: [
      {
        value: '',
        label: 'None',
      },
      {
        value: 'approved',
        label: 'Approved',
      },
      {
        value: 'draft',
        label: 'Draft',
      },
    ],
  },
  prior_auth_exumption: {
    heading: 'PA Handling',
    list: [
      { value: 'exempt', label: 'Exempt' },
      { value: 'non-exempt', label: 'Non-Exempt' },
      { value: 'carve-out-to-vendor', label: 'Carve-Out to Vendor' },
    ],
  },
  user_type: {
    heading: 'User Type',
    list: [
      { value: 'provider', label: 'Provider' },
      { value: 'member', label: 'Member' },
    ],
  },
  transaction_source: {
    heading: 'Source',
    list: [{ value: '', label: 'None' }],
  },
  'procedure-enum-status': {
    heading: 'Status',
    list: [
      { value: '', label: 'None' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
    ],
  },
  pa_status: {
    heading: 'Yes/No',
    list: [
      { value: '', label: 'None' },
      { value: 'y', label: 'Yes' },
      { value: 'n', label: 'No' },
      { value: 'u', label: 'Undetermined' },
    ],
  },
  text_field: ['text'],
  tags: ['entity-transactions-procedure_codes'],
};
export const FilterValue = ({ state, dispatch, data, indexValue }) => {
  const [filterData, setFilterData] = useState({});

  const businessLineList = useStoreState((state) => {
    return state.businessLine.businessLineList;
  });
  const clientList = useStoreState((state) => {
    return state.client?.clientList;
  });
  const settingsState = useStoreState((state) => state.settings);
  const reportState = useStoreState((state) => state.report);
  const programList = useStoreState((state) => state.programs.programList);
  const sourceList = reportState.sourceList;
  useEffect(() => {
    if (sourceList) {
      const modifiedList = sourceList.map((item) => ({
        value: item.PK,
        label: item.title,
      }));
      filterValueConfig.transaction_source.list = [{ value: '', label: 'None' }, ...modifiedList];
    }
  }, [sourceList]);

  useEffect(() => {
    const data = {
      policy_type: settingsState.policyTypeList,
      program_vendor: settingsState.vendorList,
      'instruction-record_type': [
        { title: 'Group', SK: 'GROUP' },
        { title: 'Policy', SK: 'POLICY' },
        { title: 'Procedure', SK: 'PROCEDURE' },
        { title: 'Program', SK: 'PROGRAM' },
        { title: 'Business', SK: 'BUSINESS' },
      ],
      'procedures-record_type': ProcedureRecordTypeList.map((recordType) => {
        return { title: recordType, SK: recordType };
      }),
    };
    if (businessLineList) {
      const collectionType = businessLineList.map((element) => {
        return { title: element.title, PK: element.PK };
      });
      data.businessLine = collectionType;
    }
    if (clientList) {
      const collectionType = clientList.map((element) => {
        return { title: element.title, PK: element.title };
      });
      data.clients = collectionType;
    }
    if (programList) {
      const collectionType = programList.map((element) => {
        return { title: element.shortname, PK: element.shortname };
      });
      data['programs-short'] = collectionType;
      const collectionType2 = programList.map((element) => {
        return { title: element.title, SK: element.title };
      });
      data['programs'] = collectionType2;
    }
    setFilterData(data);
  }, [
    businessLineList,
    clientList,
    programList,
    settingsState.policyTypeList,
    settingsState.vendorList,
  ]);

  if (
    (filterValueConfig.multipleSelect.includes(data.name) ||
      filterValueConfig.singleSelect.includes(data.name)) &&
    Object.keys(filterData).length > 0
  ) {
    const isMultipleSelect = filterValueConfig.multipleSelect.includes(
      data.name,
    );
    if (isMultipleSelect){
      let values = data.value;
      if(!Array.isArray(values) && values){
        values = values.split(",").map(item=>({title:item,PK:item}));
      }
      return (
        <Autocomplete
          multiple
          options={filterData[filterValueConfig.mapping[data.name]]}
          disableCloseOnSelect
          value={values}
          getOptionLabel={(option) => option.title}
          onChange={(e, value) => {
            dispatch({
              type: ACTIONLIST.UPDATE_FILTER_STATUS,
              payload: {
                value,
                index: indexValue,
              },
            });
          }}
          getOptionSelected={(option, value) => option.PK === value.PK}
          renderOption={(option, { selected }) => (
            <>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                color="primary"
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.title}
            </>
          )}
          renderInput={(params) => (
            <TextField
              required
              {...params}
              variant="outlined"
              label={data.title}
            />
          )}
        />
      );}
    else
      return (
        <FormControl variant="outlined" fullWidth>
          <InputLabel id={`label-${data.name}`}>Select Value</InputLabel>
          <Select
            labelId={`label-${data.name}`}
            value={data.value}
            onChange={(e) => {
              dispatch({
                type: ACTIONLIST.UPDATE_FILTER_STATUS,
                payload: {
                  value: e.target.value,
                  index: indexValue,
                },
              });
            }}
            label={'Select Value'}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {filterData[filterValueConfig.mapping[data.name]].map(
              (value, index) => {
                return (
                  <MenuItem key={index} value={value.SK}>
                    {value.title}
                  </MenuItem>
                );
              },
            )}
          </Select>
        </FormControl>
      );
  }

  if (filterValueConfig.status.includes(data.data_type)) {
    const filterData = filterValueConfig[data.data_type];
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel id={'label'}>{filterData.heading}</InputLabel>
        <Select
          label="Status"
          value={data.value}
          onChange={(e) => {
            const { value } = e.target;
            dispatch({
              type: ACTIONLIST.UPDATE_FILTER_STATUS,
              payload: { value, index: indexValue },
            });
          }}
        >
          {filterData.list.map((item) => {
            return (
              <MenuItem value={item.value} key={item.label}>
                {item.label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  }

  if (data.data_type == 'date') {
    return (
      <Grid container>
        <Grid item sm={data.operator == 'range' ? 6 : 12}>
          <KeyboardDatePicker
            margin="normal"
            variant="inline"
            fullWidth
            inputVariant="outlined"
            format={globalDateEntity.datePickerFormat}
            autoOk
            value={data.value?.startDate || null}
            label={data.operator != 'range' ? 'Date' : 'Start Date'}
            onChange={(value) =>
              dispatch({
                type: ACTIONLIST.UPDATE_FILTER_STATUS,
                payload: {
                  value: {
                    ...data.value,
                    startDate: moment(value).format(
                      globalDateEntity.datePickerFormat,
                    ),
                  },
                  index: indexValue,
                },
              })
            }
            minDate={new Date(DatepickerStartDate)}
            minDateMessage={stringConstants.minDate}
          />
        </Grid>
        {data.operator == 'range' && (
          <Grid item sm={6}>
            <KeyboardDatePicker
              margin="normal"
              variant="inline"
              inputVariant="outlined"
              format={globalDateEntity.datePickerFormat}
              autoOk
              style={{ marginLeft: 30 }}
              label={'End Date'}
              value={data.value?.endDate || null}
              onChange={(value) =>
                dispatch({
                  type: ACTIONLIST.UPDATE_FILTER_STATUS,
                  payload: {
                    value: {
                      ...data.value,
                      endDate: moment(value).format(
                        globalDateEntity.datePickerFormat,
                      ),
                    },
                    index: indexValue,
                  },
                })
              }
              minDate={new Date(DatepickerStartDate)}
              minDateMessage={stringConstants.minDate}
            />
          </Grid>
        )}
      </Grid>
    );
  }
  if (filterValueConfig.tags.includes(data.name)) {
    let value = data.value;
    if(!Array.isArray(value) && value){
      value = value.split(",");
    }
    return (
      <FormControl variant="outlined">
        <ChipInput
          style={{
            width: '100%',
            marginTop: '1s6px',
            marginBottom: '16px',
            minWidth: '100%',
          }}
          label={'Tags'}
          variant="outlined"
          value={value}
          onAdd={(chip) => {
            console.log(chip, 'chip');
            dispatch({
              type: ACTIONLIST.UPDATE_FILTER_STATUS,
              payload: { value: [...value, chip], index: indexValue },
            });
          }}
          onChange={(chip) => {
            console.log('onchange', chip);
            dispatch({
              type: ACTIONLIST.UPDATE_FILTER_STATUS,
              payload: { value: chip, index: indexValue },
            });
          }}
          onDelete={(chip) => {
            dispatch({
              type: ACTIONLIST.UPDATE_FILTER_STATUS,
              payload: {
                value: value.filter((item) => item != chip),
                index: indexValue,
              },
            });
          }}
          placeholder={'Type code and hit enter '}
        />
      </FormControl>
    );
  }
  if (filterValueConfig.text_field.includes(data.data_type)) {
    return (
      <TextField
        fullWidth
        type="text"
        variant="outlined"
        label="Value"
        placeholder="Value"
        value={data.value}
        margin="normal"
        onChange={(e) => {
          const { value } = e.target;
          dispatch({
            type: ACTIONLIST.UPDATE_FILTER_STATUS,
            payload: { value, index: indexValue },
          });
        }}
      />
    );
  }

  return null;
};
